<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <div class="d-flex" :key="generateId(schema.model)">
      <i4pro-icon-popover
        v-if="schema.attributesInfo"
        :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
        :schema="schema"
        :model="model"
      />

      <v-text-field
        :rules="rules"
        :name="schema.model"
        :id="generateId(schema.model)"
        v-bind="schema.attributesTextField"
        :disabled="schema.readonly"
        :clearable="false"
        v-model="cmpValue"
        v-bind:prefix="options.currencySymbol"
        v-bind:suffix="options.suffix"
        @blur="onBlur"
        @change="onChange"
        @focus="onFocus"
        @input="onInput"
        @keypress="keyPress"
      >
        <template v-slot:label>
          {{ schema.attributesTextField.label }}
          <span v-if="schema.rules.includes('required')" class="red--text">*</span>
        </template>
      </v-text-field>
    </div>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },
  data: () => ({
    options: {
      locale: '',
      currencySymbol: '',
      suffix: '',
      length: 0,
      decimalPlaces: 0,
      valueWhenIsEmpty: ''
    },
    defaultOptions: {
      locale: 'pt-BR',
      currencySymbol: '',
      suffix: '',
      length: 18,
      decimalPlaces: 2,
      valueWhenIsEmpty: ''
    }
  }),

  created() {
    Object.assign(this.options, this.defaultOptions, this.schema.formatDecimal);
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set e é emitido para o componente pai.
   the-vue-mask nao funciona corretamente ao incluir valores existentes no componente pai.
  */
  computed: {
    cmpValue: {
      get: function () {
        return this.value !== null && this.value !== '' && this.value !== undefined
          ? this.humanFormat(this.value.toString())
          : this.valueWhenIsEmpty;
      },
      set: function (newValue) {
        this.value = this.machineFormat(newValue);
        this.$emit('input', this.value);
      }
    }
  },
  methods: {
    humanFormat: function (number) {
      if (isNaN(number)) {
        number = '';
      } else {
        // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
        number = Number(number).toLocaleString(this.options.locale, {
          maximumFractionDigits: this.options.decimalPlaces,
          minimumFractionDigits: this.options.decimalPlaces
        });
      }
      return number;
    },
    machineFormat(number) {
      if (number) {
        number = this.cleanNumber(number);
        // Ajustar quantidade de zeros à esquerda
        number = number.padStart(parseInt(this.options.decimalPlaces) + 1, '0');
        // Incluir ponto na casa correta, conforme a precisão configurada
        number =
          number.substring(0, number.length - parseInt(this.options.decimalPlaces)) +
          '.' +
          number.substring(number.length - parseInt(this.options.decimalPlaces), number.length);
        if (isNaN(number)) {
          number = this.valueWhenIsEmpty;
        }
      } else {
        number = this.valueWhenIsEmpty;
      }
      if (this.options.decimalPlaces === 0) {
        number = this.cleanNumber(number);
      }
      return isNaN(number) ? number : 1 * number; // converte para tipo number se possível
    },
    keyPress($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
      if (this.targetLength()) {
        $event.preventDefault();
      }
    },
    // Retira todos os caracteres não numéricos e zeros à esquerda
    cleanNumber: function (value) {
      let result = '';
      if (value) {
        let flag = false;
        let arrayValue = value.toString().split('');
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            if (!flag) {
              // Retirar zeros à esquerda
              if (arrayValue[i] !== '0') {
                result = result + arrayValue[i];
                flag = true;
              }
            } else {
              result = result + arrayValue[i];
            }
          }
        }
      }
      return result;
    },
    isInteger(value) {
      let result = false;
      if (Number.isInteger(parseInt(value))) {
        result = true;
      }
      return result;
    },
    targetLength() {
      if (Number(this.cleanNumber(this.value).length) >= Number(this.options.length)) {
        return true;
      } else {
        return false;
      }
    },

    async onBlur(event) {
      await this.changeEvents(event);
    }
  }
};
</script>
